import { DecorativeDivider } from './DecorativeDivider'

export function SectionHeading({ eyebrow, title, description, largeEyebrow = false, dividerVariant = 'heart' }: { eyebrow?: string; title: string; description?: string; largeEyebrow?: boolean; dividerVariant?: 'heart' | 'note' }) {
  return <div className="section-heading">{eyebrow && <p className={largeEyebrow ? 'eyebrow eyebrow--large' : 'eyebrow'}>{eyebrow}</p>}<h2>{title}</h2><DecorativeDivider variant={dividerVariant} />{description && <p>{description}</p>}</div>
}
